var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{ref:"placeholder",staticClass:"media media--orientation-landscape",style:({
    'background': _vm.background,
  }),attrs:{"src":require("@/assets/icons/placeholder.png"),"alt":_vm.$t('peer.placeholderAlt', { color: _vm.background })},on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }